import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type UserProjectCodio = {
  userId: number;
  projectId: number;
  token: string;
};

type UserProjectParams = {
  userId: number;
  projectId: number;
};

type CreateSessionParams = {
  studentId: number;
  projectId: number;
  sessionDate: string;
  mentorId?: number;
};

const { useGet: useUserProject, useCreate: useBookPresentation } = getCRUDHooks({
  entityName: 'userProjects',
  sharedCacheEntities: ['projectSessions'],
  withLinks: true,
  get: ({ userId, projectId }: UserProjectParams) =>
    clientApi.getOCClient().helpers.user.users.id(userId).projects.get(projectId),
  create: ({ studentId, projectId, sessionDate, mentorId }: CreateSessionParams) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(studentId)
      .projects.id(projectId)
      .bookPresentation.create({ sessionDate, mentorId }),
});

const { useCreate: useProjectsFollow } = getCRUDHooks({
  entityName: 'userProjectsFollow',
  sharedCacheEntities: ['userProjects'],
  create: ({ userId, projectId }: UserProjectParams) =>
    clientApi.getOCClient().helpers.user.users.id(userId).projects.id(projectId).follow.create(),
});

const { useCreate: useProjectsUnfollow } = getCRUDHooks({
  entityName: 'userProjectsUnfollow',
  sharedCacheEntities: ['userProjects'],
  create: ({ userId, projectId }: UserProjectParams) =>
    clientApi.getOCClient().helpers.user.users.id(userId).projects.id(projectId).unfollow.create(),
});

const { useGet: useUserProjectsProjectSessions } = getCRUDHooks({
  entityName: 'userProjectSessions',
  get: ({ userId, projectId }: UserProjectParams) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .projects.id(projectId)
      .projectSessions.get(),
});

const { useGet: useUserProjectSections } = getCRUDHooks({
  entityName: 'useUserProjectSections',
  get: ({ userId, projectId }: UserProjectParams) =>
    clientApi.getOCClient().helpers.user.users.id(userId).projects.id(projectId).sections.find(),
});

const { useGet: useUserProjectsGenerateCodioLtiSignature } = getCRUDHooks({
  entityName: 'userProjectCodioLtiSignature',
  get: ({ userId, projectId, token }: UserProjectCodio) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .projects.id(projectId)
      .generateCodioLtiSignature.get(null, false)
      .setQueryParams({
        ltiIntegrationToken: token,
      })
      .execute(),
});

export {
  useUserProjectSections,
  useUserProject,
  useBookPresentation,
  useProjectsFollow,
  useProjectsUnfollow,
  useUserProjectsProjectSessions,
  useUserProjectsGenerateCodioLtiSignature,
};
